<template>
  <div class="advance-payment">
    <div>
      <p class="title">
        <span>暨南大学附属第一医院</span>
      </p>
    </div>
    <van-form @submit="onSubmit">
      <van-cell-group inset>
        <van-field
          v-model="form.name"
          is-link
          readonly
          @click="state.showPicker = true"
          label="类型"
          placeholder="请选择类型"
        />
        <van-popup v-model:show="state.showPicker" position="bottom">
          <van-picker
            :columns="state.columns"
            :default-index="form.type == 1 ? 0 : 1"
            @confirm="onConfirm"
            @cancel="state.showPicker = false"
          />
        </van-popup>
        <div class="number-content">
          <van-field
            v-model="form.caseHistoryNo"
            :label="form.type == 1 ? `门诊号` : `住院号`"
            placeholder="请输入"
          />
          <van-button type="primary" size="mini" @click="queryBtn">
            查询
          </van-button>
        </div>
        <van-field readonly v-model="patientName" label="患者姓名" />
        <van-field readonly v-model="accountAmount" label="当前金额(元)" />
        <van-field
          type=" number"
          v-model="form.money"
          :readonly="!patientName"
          placeholder="请输入要充值的金额"
          label="充值金额(元)"
        />
      </van-cell-group>
      <van-row style="padding: 0 10px; margin-top: 20px">
        <el-col span="24">
          <p style="padding: 5px 0; font-size: 14px !important">
            肠内营养干预预缴费退费方式：
          </p>
          <p
            style="
              padding: 5px 0;
              padding-left: 10px;
              font-size: 14px !important;
              color: #999;
            "
          >
            1、通过拨打电话 (020) 3868 8863 进行退费；
          </p>
          <p
            style="
              padding: 5px 0;
              padding-left: 10px;
              font-size: 14px !important;
              color: #999;
            "
          >
            2、前往肠内营养配制室（7号楼一楼肠内营养配制室）进行退费。
          </p>
          <p
            style="
              padding: 5px 0;
              padding-left: 10px;
              font-size: 14px !important;
              color: #999;
            "
          >
            注：退费时间为周一到周六8：30-18：30
          </p>
        </el-col>
      </van-row>
      <div style="margin: 40px">
        <van-button
          :disabled="!patientName"
          round
          block
          type="success"
          native-type="submit"
        >
          立即充值
        </van-button>
      </div>
    </van-form>
  </div>
</template>
<script setup>
import {
  advancePaymentInfo,
  createAdvancePaymentOrder,
} from "@/api/prescription/prescription";
import { reactive, toRefs } from "vue";
import { Notify, Dialog } from "vant";
const state = reactive({
  columns: [
    {
      text: "门诊",
      value: 1,
    },
    {
      text: "住院",
      value: 2,
    },
  ],
  result: "",
  showPicker: false,
  form: {
    type: 2,
    name: "住院",
  },
  patientInfo: {},
  accountAmount: null,
  patientName: "",
});
// 选择类型
const onConfirm = (val) => {
  state.form.name = val.text;
  state.form.type = val.value;
  state.showPicker = false;
};
// 查询按钮
const queryBtn = () => {
  let typeText = state.form.type == 1 ? "门诊号" : "住院号";
  if (state.form.caseHistoryNo) {
    advancePaymentInfo({
      type: state.form.type,
      caseHistoryNo: state.form.caseHistoryNo,
    }).then((v) => {
      const { data } = v;
      state.patientName = data.patientName;
      state.accountAmount = data.accountAmount;
    });
  } else {
    Notify({ type: "warning", message: `请输入${typeText}` });
  }
};

// 立即充值
const onSubmit = () => {
  const path = window.location.host;
  if (state.form.money) {
    Dialog.confirm({
      title: "信息提示",
      message: "请仔细核对信息！避免充值有误。",
      confirmButtonText: "确定",
      cancelButtonText: "取消",
      confirmButtonColor: "#1989fa",
    })
      .then(() => {
        const params = {
          type: state.form.type,
          caseHistoryNo: state.form.caseHistoryNo,
          money: state.form.money,
        };
        createAdvancePaymentOrder(params).then((v) => {
          const { data } = v;
          window.location.replace(data);
          // Notify({ type: "success", message: `充值成功` });
        });
      })
      .catch(() => {
        // on cancel
      });
  } else {
    Notify({ type: "warning", message: `请输入充值金额` });
  }
};
const { form, patientInfo, accountAmount, patientName } = toRefs(state);
</script>
<style lang="scss" scoped>
.advance-payment {
  .title {
    text-align: center;
    padding: 10px 0;
    background: #999;
    color: #fff;
    font-size: 16px;
  }
  .number-content {
    display: flex;
    align-items: center;
    .van-field {
      width: 85%;
    }
    button {
      padding: 0 10px;
    }
  }
}
</style>
